var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWarningRed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9545 8.88418L43.4921 34.1144C43.812 34.8675 43.952 35.4799 43.992 36.116C44.072 37.6024 43.552 39.0471 42.5322 40.1589C41.5124 41.2667 40.1326 41.9207 38.6329 42H9.35781C8.73791 41.9623 8.11802 41.8216 7.53811 41.6036C4.6386 40.4344 3.23884 37.1446 4.41864 34.2928L19.0562 8.86635C19.5561 7.97256 20.316 7.20164 21.2558 6.70619C23.9753 5.19804 27.4348 6.18894 28.9545 8.88418ZM25.735 25.5115C25.735 26.4627 24.9552 27.2574 23.9953 27.2574C23.0355 27.2574 22.2356 26.4627 22.2356 25.5115V19.905C22.2356 18.9517 23.0355 18.1808 23.9953 18.1808C24.9552 18.1808 25.735 18.9517 25.735 19.905V25.5115ZM23.9953 34.0352C23.0355 34.0352 22.2356 33.2405 22.2356 32.2912C22.2356 31.3379 23.0355 30.5452 23.9953 30.5452C24.9552 30.5452 25.735 31.3201 25.735 32.2694C25.735 33.2405 24.9552 34.0352 23.9953 34.0352Z",
    fill: "#DC2804"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/WarningRed.8ef61f1e.svg";
export { ForwardRef as ReactComponent };